/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import {
  SlackPersonAccount,
  SlackPersonAccount$inboundSchema,
} from "./slackpersonaccount.js";

export type ListPersonAccountsResponseBody = {
  /**
   * Up to 50 current mappings, one entry per workspace membership.
   */
  accounts: Array<SlackPersonAccount>;
  /**
   * Cursor for the next page, when present.
   */
  nextCursor?: string | undefined;
};

/** @internal */
export const ListPersonAccountsResponseBody$inboundSchema: z.ZodMiniType<
  ListPersonAccountsResponseBody,
  unknown
> = z.pipe(
  z.object({
    accounts: z.array(SlackPersonAccount$inboundSchema),
    next_cursor: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      "next_cursor": "nextCursor",
    });
  }),
);

export function listPersonAccountsResponseBodyFromJSON(
  jsonString: string,
): SafeParseResult<ListPersonAccountsResponseBody, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => ListPersonAccountsResponseBody$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'ListPersonAccountsResponseBody' from JSON`,
  );
}
